// import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { VCardTitle } from 'vuetify/components/VCard'
import { useConfigStore } from '@/stores/config' // Importar el store
import type { Pinia } from 'pinia'
import { mdi } from 'vuetify/iconsets/mdi-svg'
import {
	mdiHospital,
	mdiAccountGroup,
	mdiCurrencyUsd,
	mdiStethoscope,
	mdiPhone,
	mdiChartTimelineVariantShimmer,
	mdiStarFourPointsOutline,
	mdiMinus,
	mdiPlus,
	mdiAccountGroupOutline,
	mdiCashMultiple,
	mdiTruckDeliveryOutline,
	mdiAccountTie,
	mdiDomain,
	mdiStorefrontOutline,
	mdiDatabaseOff,
	mdiClipboardAlertOutline,
	mdiEyeOffOutline,
	mdiChartBarStacked,
	mdiCheck,
	mdiCloseCircleOutline,
	mdiHospitalBox,
	mdiMagnify,
	mdiHandHeart,
	mdiLightbulb,
	mdiLinkVariant,
	mdiEmoticonHappy,
	mdiHeart,
	mdiStar,
	mdiHandshake,
	mdiForum,
	mdiSpa,
	mdiAccountCheck,
	mdiClipboardCheck,
	mdiCalendarCheck,
	mdiMessageTextOutline,
	mdiEmail,
	mdiMapMarker,
	mdiWeatherSunny,
	mdiWeatherNight,
	mdiFacebook,
	mdiInstagram,
	mdiTwitter,
	mdiLinkedin,
	mdiYoutube,
	mdiWhatsapp,
	mdiTrendingUp,
	mdiSpeedometer,
	mdiShieldLock,
	mdiCheckDecagram,
} from '@mdi/js'

export default defineNuxtPlugin((nuxtApp) => {
	const configStore = useConfigStore(nuxtApp.$pinia as Pinia) // Pasar la instancia de Pinia

	const vuetify = createVuetify({
		ssr: true,
		icons: {
			defaultSet: 'mdi',
			sets: { mdi },
			aliases: {
				mdiHospital,
				mdiAccountGroup,
				mdiCurrencyUsd,
				mdiStethoscope,
				mdiPhone,
				mdiChartTimelineVariantShimmer,
				mdiStarFourPointsOutline,
				mdiMinus,
				mdiPlus,
				mdiAccountGroupOutline,
				mdiCashMultiple,
				mdiTruckDeliveryOutline,
				mdiAccountTie,
				mdiDomain,
				mdiStorefrontOutline,
				mdiDatabaseOff,
				mdiClipboardAlertOutline,
				mdiEyeOffOutline,
				mdiChartBarStacked,
				mdiCheck,
				mdiCloseCircleOutline,
				mdiHospitalBox,
				mdiMagnify,
				mdiHandHeart,
				mdiLightbulb,
				mdiLinkVariant,
				mdiEmoticonHappy,
				mdiHeart,
				mdiStar,
				mdiHandshake,
				mdiForum,
				mdiSpa,
				mdiAccountCheck,
				mdiClipboardCheck,
				mdiCalendarCheck,
				mdiMessageTextOutline,
				mdiEmail,
				mdiMapMarker,
				mdiWeatherSunny,
				mdiWeatherNight,
				mdiFacebook,
				mdiInstagram,
				mdiTwitter,
				mdiLinkedin,
				mdiYoutube,
				mdiWhatsapp,
				mdiTrendingUp,
				mdiShieldLock,
				mdiSpeedometer,
				mdiCheckDecagram 
			}
		},
		display: {
			mobileBreakpoint: 'sm'
		},
				aliases: {
			VSectionTitle: VCardTitle
		},
		defaults: {
			VContainer: { width: '100%' },
			VCardTitle: {
				variant: 'flat',
				class: 'text-wrap  px-0 px-sm-auto'
			},
			VCardText: {
				class: 'text-wrap px-0 px-sm-auto'
			},
			VSectionTitle: {
				tag: 'h2',
				class: 'text-h4 text-sm-h4 text-md-h3 pb-3 pb-md-6 text-center text-accent text-wrap'
			},
			VTabs: { class: 'my-4' },
			VTab: {
				class: 'text-h6',
				color: 'secondary',
				rounded: true
			},
			VBtn: {
				class: 'px-4',
			}
		},
		theme: {
		defaultTheme: configStore.getCurrentTheme,

    themes: {
      'light-medium-contrast': {
        colors: {
          background: '#e4e8f3',
          surface: '#f8f9ff',
          'surface-dim': '#c2c6d1',
          'surface-bright': '#f8f9ff',
          'on-surface': '#0c1119',
          outline: '#50525e',
          'outline-variant': '#6b6c79',
          primary: '#28409C',
          'on-primary': '#ffffff',
          secondary: '#00395e',
          'on-secondary': '#ffffff',
          tertiary: '#35363b',
          'on-tertiary': '#ffffff',
          error: '#740006',
          'on-error': '#ffffff',
          'surface-light': '#e4e8f3',
        },
        dark: false,
        variables: {
          'overlay-background': '#191b25',
        },
      },
      'light-high-contrast': {
        colors: {
          background: '#dee2ed',
          surface: '#f8f9ff',
          'surface-dim': '#b4b9c3',
          'surface-bright': '#f8f9ff',
          'on-surface': '#000000',
          outline: '#2a2b36',
          'outline-variant': '#474854',
          primary: '#28409C',
          'on-primary': '#ffffff',
          secondary: '#002e4e',
          'on-secondary': '#ffffff',
          tertiary: '#2b2c30',
          'on-tertiary': '#ffffff',
          error: '#600004',
          'on-error': '#ffffff',
          'surface-light': '#e4e8f3',
        },
        dark: false,
        variables: {
          'overlay-background': '#191b25',
        },
      },
      'dark-medium-contrast': {
        colors: {
          background: '#232830',
          surface: '#0f141b',
          'surface-dim': '#0f141b',
          'surface-bright': '#40454d',
          'on-surface': '#ffffff',
          outline: '#b0b1bf',
          'outline-variant': '#8f8f9d',
          primary: '#28409C',
          'on-primary': '#f0efff',
          secondary: '#c4dfff',
          'on-secondary': '#002744',
          tertiary: '#dddbe2',
          'on-tertiary': '#24252a',
          error: '#ffd2cc',
          'on-error': '#540003',
          'surface-light': '#343942',
        },
        dark: true,
        variables: {
          'overlay-background': '#191b25',
        },
      },
      'dark-high-contrast': {
        colors: {
          background: '#2c3139',
          surface: '#0f141b',
          'surface-dim': '#0f141b',
          'surface-bright': '#4b5059',
          'on-surface': '#ffffff',
          outline: '#efeffe',
          'outline-variant': '#c1c1d0',
          primary: '#28409C',
          'on-primary': '#ffffff',
          secondary: '#e7f1ff',
          'on-secondary': '#000000',
          tertiary: '#f1eff5',
          'on-tertiary': '#000000',
          error: '#ffece9',
          'on-error': '#000000',
          'surface-light': '#343942',
        },
        dark: true,
        variables: {
          'overlay-background': '#191b25',
        },
      },
    },
		},

	})

	nuxtApp.vueApp.use(vuetify)
})
